import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { toollist } from 'src/app/buildings/buildings/buildings.tools';
import { ApiService } from 'src/app/custom-material/Services';
import { globalData } from '../../Models/global.model';

@Component({
  selector: 'main-toolbar',
  templateUrl: './t_toolbar.component.html',
  styleUrls: ['./toolbar.component.less']
})
export class ToolbarComponent implements OnInit {

  @Input() toollist:Array<object>;

  constructor(
    public gd: globalData) {}

  ngOnInit(): void {}

  send(event)
  {
        this.gd.toolService[event.Method]();
  }
  conditionSatisfied(tool)
  {
    if(!tool.Condition) return true;
     if(this[tool.Condition]!==undefined) return this[tool.Condition];
    if(this.gd.toolService[tool.Condition]!==undefined) return this.gd.toolService[tool.Condition];
    if(this.gd[tool.Condition]!=undefined) return this.gd[tool.Condition];
    return false;
  }


  get isSuperadmin() {
    return this.gd.connectedUser.state==3;
  }
  get isAdmin() {
    return this.gd.connectedUser.state>=2;
  }
  get isAuditor() {
    return this.gd.connectedUser.isAuditor;
  }

}
